import React, { useRef, useEffect } from "react";
import ReviewsLayout from "../../../sections/CustomerDashboard/Inbox/Reviews/ReviewsLayout";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import Masonry from "masonry-layout";
import ReviewsOverTimeWidget from "../../../components/CustomerDashboard/ReviewsOverTimeWidget";
import ReviewsMapWidget from "../../../components/CustomerDashboard/ReviewsMapWidget";
import { CUSTOMER_PAGE_TITLE_CLASS } from "../../../sections/CustomerDashboard/shared/customerLayoutSpec";

const CustReviews = () => {
  const masonryGridRef = useRef(null);
  useEffect(() => {
    if (masonryGridRef.current) {
      try {
        const images = masonryGridRef.current.querySelectorAll('img');
        const imagePromises = Array.from(images).map((img) => {
          if (img.complete) return Promise.resolve();
          return new Promise((resolve) => {
            img.onload = resolve;
            img.onerror = resolve;
          });
        });
        Promise.all(imagePromises).then(() => {
          if (masonryGridRef.current && typeof Masonry !== 'undefined') {
            const masonry = new Masonry(masonryGridRef.current, {
              itemSelector: '.masonry-item',
              columnWidth: 10,
              gutter: 0,
            });
            const handleResize = () => masonry && masonry.layout && masonry.layout();
            window.addEventListener('resize', handleResize);
            if (masonryGridRef.current) {
              masonryGridRef.current.masonry = masonry;
            }
            return () => {
              window.removeEventListener('resize', handleResize);
              if (masonryGridRef.current?.masonry) {
                masonryGridRef.current.masonry.destroy();
              }
            };
          }
        });
      } catch (e) {
        console.warn('Masonry failed to init on reviews page:', e);
      }
    }
  }, []);

  return (
    <DashboardMainContainer className="!bg-white">
      <div className="w-full">
        <div ref={masonryGridRef} className="masonry-grid">
          <ReviewsMapWidget />
          <ReviewsOverTimeWidget />
        </div>

        <div className={`flex justify-center ${CUSTOMER_PAGE_TITLE_CLASS}`}>
          <ReviewsLayout />
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default CustReviews;
